import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import Link from '@mui/material/Link';
import { config } from '../../config';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const Agreements: FC = () => {
  return (
    <StyledTypography variant="body1" mt={2}>
      <Trans
        i18nKey={'auth.signUp.agreements'}
        components={{
          LinkEULA: <Link href={config.linkEula} target={'_blank'} rel={'noopener noreferrer'} color={'inherit'} />,
          LinkPP: (
            <Link href={config.linkPrivacyPolicy} target={'_blank'} rel={'noopener noreferrer'} color={'inherit'} />
          ),
        }}
      ></Trans>
    </StyledTypography>
  );
};
